module.exports = __webpack_public_path__ + "static/media/cross-red.2efd2f56.svg";